import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./SelectSupplier.css";
import TextInput from "../UIkit/TextInput";
import SearchIcon from "@mui/icons-material/Search";
import DropdownList from "./DoropdownList";
import { toKanaString } from "../../functions/common";
import { getSuppliersRecords } from "../../functions/suppliers";
import classModule from "./SelectSupplier.module.scss";
const useStyles = makeStyles((theme) => ({
  userSearch: {
    display: "flex",
    alignItems: "center",
  },
  searchButton: {
    marginTop: "20px",
    width: "24px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#757575",
  },
}));

const SelectSupplier = (props) => {
  const classes = useStyles();
  const {
    companynumber,
    setCompanynumber,
    companyname,
    setCompanyname,
    companynamefull,
    setCompanynamefull,
    setShowSelectBillingCompany,
  } = props;
  const [searchWords, setSearchWords] = useState(""); //名称
  const [supplierList, setSupplierList] = useState([]);
  //カナが入力されたとき
  const inputSearchWords = useCallback(
    (event) => {
      // const convStr = toKanaString(event.target.value);
      // setSearchWords(convStr);
      // //console.log(convStr);
      // event.target.value = convStr;
      const rawValue = event.target.value;
      // let convStr = toKanaString(rawValue); // 変換処理
      // if(convStr.length > rawValue.length){
      //   convStr = convStr.substring(0, rawValue.length);
      // }
      setSearchWords(rawValue);
    },
    [setSearchWords]
  );
  //検索ボタンが押されたとき
  const handlesearchButtonClick = async () => {
    //検索処理
    if (searchWords.length === 0) {
      setSupplierList([]);
      return;
    }
    try {
      const convStr = toKanaString(searchWords);
      const records = await getSuppliersRecords(convStr);
      //console.log(records);
      const names = [];
      records.forEach(function (record) {
        names.push([
          record.A153_gasicd.value,
          record.A153_gasinm.value,
          record.A153_gasina.value,
        ]);
      });
      names.sort(function (a, b) {
        if (Number(a[0]) < Number(b[0])) return -1;
        if (Number(a[0]) > Number(b[0])) return 1;
        return 0;
      });

      setSupplierList(names);
    } catch (error) {
      console.log("Error during search: ", error);
    }
  };
  //決定ボタンが押されたとき
  const handleDecideButtonClick = () => {
    setShowSelectBillingCompany(false);
  };
  //キャンセルボタンが押されたとき
  const handleCancelButtonClick = () => {
    setCompanynumber("");
    setCompanyname("");
    setCompanynamefull("");
    setShowSelectBillingCompany(false);
  };
  // const names = [
  //   ['03111','林  翔太','101','総務部システム課'],
  //   ['2761','渡部  翔','101','総務部システム課'],
  //   ['1151','長谷川  義浩','101','総務部システム課'],
  //   ['  エラー','見つかりませんでした','101',''],
  //   ['03112','林  翔太','101','総務部システム課'],
  //   ['2762','渡部  翔','101','総務部システム課'],
  //   ['1152','長谷川  義浩','101','総務部システム課'],
  // ];
  return (
    <aside className={classModule.modalContainer}>
      <div className={classModule.modal}>
        <h2 className="u-text__headline u-text-center">派遣・協力会社検索</h2>
        <div className={classes.userSearch}>
          <TextInput
            fullWidth={true}
            label={"名称かな（前方一致）"}
            multiline={false}
            required={true}
            minRows={1}
            type={"text"}
            onChange={inputSearchWords}
            value={searchWords}
          />
          <button
            className={classes.searchButton}
            onClick={handlesearchButtonClick}
          >
            <SearchIcon />
          </button>
        </div>
        <DropdownList
          supplierList={supplierList}
          setCompanynumber={setCompanynumber}
          setCompanyname={setCompanyname}
          setCompanynamefull={setCompanynamefull}
        />
        <div className={classModule.buttons}>
          <button
            className={classModule.okButton}
            onClick={handleDecideButtonClick}
          >
            決定
          </button>
          <button
            className={classModule.ngButton}
            onClick={handleCancelButtonClick}
          >
            キャンセル
          </button>
        </div>
      </div>
    </aside>
  );
};

export default SelectSupplier;
